import { Component, OnInit } from "@angular/core";
import { HoshinBudgetService } from "../hoshin-budget.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { DatePipe } from "@angular/common";
import { SelfService } from "src/app/bpg-self-services/self-services.service.ts";
import { Router } from "@angular/router";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { BpgCommonService } from "src/app/bpg-common/services/bpg-common.service";

@Component({
  selector: "app-hoshin",
  templateUrl: "./hoshin.component.html",
  styleUrls: ["./hoshin.component.css"],
})
export class HoshinComponent implements OnInit {
  //common
  adminId = localStorage.getItem("adminId");
  loginData: any = JSON.parse(localStorage.getItem("loginData"));
  userId: any = this.loginData["userId"];
  yearList: any = [];
  displayType: string;
  fiscalYear: any;
  removeToolbar: any = {
    disableNativeSpellChecker: false,
    toolbar: "Basic",
    uiColor: "#FFFFFF",
    basicEntities: false,
    fillEmptyBlocks: false,
    removeButtons:
      "Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat",
    height: "130px",
    Backgroundcolor: "black !important",
  };
  siteName: any;
  bpgName: any;
  chapterId: any;
  method: string;
  param: string;
  msg: string;
  overallStatus: string;
  //new initiative
  affinityGoals: any;
  chapterGoals: any;
  bpgInitiative: any;
  businessDrivers: any;
  frequency: any;
  proposedBudget: any;
  approvedBudget: any;
  leadId1: any;
  leadId2: any;
  additionalFunding: any;
  additionalFundingSource: any;
  actionPlan: any;
  businessDriversList: any = [];
  frequencyList: any = [];
  maxDate: any;
  minDate: any;
  initiativeList: any = [];
  kpiList: any = [];
  selectedKpiList: any = [];
  estimatedTiming: any;
  selectedMonthYear: any;
  prevFy: any;
  prevFyShort: any;
  prevAffinityGoals: any;
  prevchapterGoals: any;
  prevInitiativeList: any = [];
  hoshinId: any;
  addCustomKpi = false;
  errorMsg = "";
  errorMsgForMissingKpi = "";
  selectedChapter = false;
  bpgList: any = [];
  siteList: any = [];
  siteId: any = null;
  bpgId: any = null;
  //review details

  highlights: any;
  challenges: any;
  hoshinList: any = [];
  hoshinBase: any;
  isKpiReviewSelected = true;
  isOverallReviewSelected = false;
  isDetailsClicked = true;
  isKpiClicked = false;
  isGoalsSelected = true;
  isInitiativesSelected = false;
  isAddNewInitiative = false;
  kpiName: any;
  kpiCount: any;
  isViewClicked = false;
  newkpiCount = 0;
  selectedKpi: string;
  isEditKpi: boolean;
  isNextYearPlanCompleted: boolean;
  hoshinSuccess: boolean;
  userList: any;
  kpiSuccess: boolean;
  kpiNameEditable = false;
  kpiExist = false;
  kpi: any;
  isCloned: boolean;
  isAddNewInitiativeButtonSelected: boolean;
  cloneDisable = false;
  isAddNewInitiativeSelected: boolean;
  initiativeName: any;

  //approval
  approveOrRejectHoshin = false;
  approvedAmount: number;
  hoshinApproveClicked = false;
  approveRejectComment = "";
  hoshinApproved = false;
  hoshinRejected = false;
  hoshinSubmitted = false;
  readOnly = false;
  isSuperAdminApproved: any;
  isAllHoshinsApproved = false;
  resetHoshinEvaluation: any = [];
  totalProposedBudget: any;
  totalApprovedBudget: any = "-";
  adminsEdit = false;
  claimedAmount: any;
  printClicked: boolean;
  userAndRoleIdDTO: { userId: any; roleId: string; };
  pastHoshinList: any = [];
  isbpgAdmin: boolean;
  isbpgLeadAdmin: boolean;
  isNaacAdmin: boolean;
  superAdminApprovalComments: any;
  newApprovedAmountGreater: boolean;
  errorMsgForMissingMandatoryFields = '';
  hoshinSubmit: boolean;
  isAdditionalFundingSelected = false;
  isAnyInitiativeRejected = false;
  overallHoshinApproved = false;
  overallHoshinRejected = false;
  submitButtonClicked = false;
  kpiReviewMissingFields = '';
  overallReviewMissingFields = '';
  reviewSubmittedYear: any;
  saveKPIReviewDTO: { hoshinId: any; evaluation: string; };
  goalsReview: any;
  enableSaveInitiativeButton = false;
  singleChapterAdmin = false;
  printHoshinsList: any = [];
  currentHoshin: any = [];
  kpiReviewSaved: boolean;
  dataTargetConstant = 'data-target';
  dataToggleConstant = 'data-toggle';
  fiscalYearString: any;
  currentFiscalYear:any;

  constructor(
    private readonly hoshinService: HoshinBudgetService,
    private readonly  spinner: Ng4LoadingSpinnerService,
    private readonly datepipe: DatePipe,
    private readonly userService: SelfService,
    private readonly router: Router,
    private readonly bpgCommonService: BpgCommonService
  ) { }

  isCurrentHoshinIncomplete = true;

  kpiDisable() {
    if (this.bpgInitiative &&
      this.businessDrivers &&
      this.proposedBudget>=0 &&
      this.actionPlan &&
      this.frequency && this.hoshinId !== 0) {
      if (this.frequency.toLowerCase() === 'once') {
        if (this.estimatedTiming) {
          return false;
        }
      } else {
        return false
      }
    }
    return true;
  }
  ngOnInit() {
    this.logUserAction();
    this.userAndRoleIdDTO = {
      userId: this.loginData['userId'],
      roleId: localStorage.getItem('adminId')
    }

    if (
      localStorage.getItem("loginData") === null ||
      localStorage.getItem("loginData") === undefined
    ) {
      this.router.navigate(["/log-out"]);
    }


    if (localStorage.getItem("logOutFlag") === "true") {
      this.router.navigate(["/log-out"]);
    }
    if (localStorage.getItem("isbpgAdmin") === "true") {
      this.isbpgAdmin = true;
    }
    if (localStorage.getItem("isbpgLeadAdmin") === "true") {
      this.isbpgLeadAdmin = true;
    }
    if (localStorage.getItem("isNaacAdmin") === "true") {
      this.isNaacAdmin = true;
    }
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || (this.isbpgLeadAdmin || this.isbpgAdmin) || (this.isbpgAdmin && this.isbpgLeadAdmin && this.isNaacAdmin) || this.adminId === '4' || this.isNaacAdmin) {
      this.siteId = sessionStorage.getItem('siteIdForHoshin');
      this.bpgId = sessionStorage.getItem('bpgIdForHoshin');
      this.fetchData();
    }
    this.businessDriversList = [
      { type: "Team Member Engagement" },
      { type: "Community Engagement" },
      { type: "Workforce Readiness" },
      { type: "Business Support"}
    ];

    this.frequencyList = [
      { type: "Once" },
      { type: "Monthly" },
      { type: "Quarterly" }
    ];

    if (localStorage.getItem("isMultiChapterAdmin") !== "true") {
      this.singleChapterAdmin = true;
    }
  }

  fetchData() {

    this.resetAllData();
    this.fetchPrintHoshins();

  }
  fetchPrintHoshins() {
    this.spinner.show();
    const hoshinData = {
      "userId": this.userId,
      "adminId": this.adminId,
      'bpgId': this.bpgId,
      'siteId': this.siteId
    }

    this.hoshinService.getPastHoshins(hoshinData).subscribe(res => {
      if (res != null && res !== undefined) {
        if (res.pastHoshins.length > 0) {
          this.pastHoshinList = res.pastHoshins;
        }
        if (res.currentHoshin != null) {
          this.currentHoshin.push(res.currentHoshin);
          this.printHoshinsList = [...this.printHoshinsList, ...this.currentHoshin];
        }
        if (this.pastHoshinList.length > 0) {
          this.pastHoshinList[0].show = true;
          this.printHoshinsList = [...this.printHoshinsList, ...this.pastHoshinList];
        }
        if (this.adminId === '4' || this.isNaacAdmin) {
          this.selectedChapter = true;
        }

      }
      setTimeout(() => {
        this.spinner.hide();
      }, 2000);
    })

  }

  selectHoshin(budgetId) {
    this.spinner.show();
    for (const printHoshin of this.printHoshinsList) {
      if (printHoshin.budgetId === budgetId) {
        printHoshin.show = true;
      }
      else {
        printHoshin.show = false;
      }
    }
    setTimeout(() => {
      this.printHoshin();
    }, 2000);
  }
  resetAllData() {

    //new initiative
    this.affinityGoals = null;
    this.chapterGoals = null;
    this.bpgInitiative = null;
    this.businessDrivers = null;
    this.frequency = null;
    this.proposedBudget = null;
    this.approvedBudget = null;
    this.leadId1 = null;
    this.leadId2 = null;
    this.additionalFunding = null;
    this.additionalFundingSource = null;
    this.actionPlan = null;
    this.initiativeList = [];
    this.estimatedTiming = null;
    this.selectedMonthYear = null;
    this.prevFy = null;
    this.prevFyShort = null;
    this.prevAffinityGoals = null;
    this.prevchapterGoals = null;
    this.prevInitiativeList = [];
    this.hoshinId = null;
    this.addCustomKpi = false;
    this.errorMsg = "";
    this.errorMsgForMissingKpi = "";
    this.isAdditionalFundingSelected = false;

    this.highlights = null;
    this.challenges = null;
    this.hoshinList = [];
    this.hoshinBase = null;

    this.isKpiReviewSelected = true;
    this.isOverallReviewSelected = false;
    this.isDetailsClicked = true;
    this.isKpiClicked = false;
    this.isGoalsSelected = true;
    this.isInitiativesSelected = false;
    this.isAddNewInitiative = false;
    this.kpiName = null;
    this.kpiCount = null;
    this.isViewClicked = false;
    this.newkpiCount = 0;
    this.selectedKpi = '';
    this.isEditKpi = false;
    this.isNextYearPlanCompleted = false;
    this.hoshinSuccess = false;
    this.userList = [];
    this.kpiSuccess = false;
    this.kpiNameEditable = false;
    this.kpiExist = false;
    this.kpi = null;
    this.isCloned = false;
    this.isAddNewInitiativeButtonSelected = false;
    this.cloneDisable = false;
    this.isAddNewInitiativeSelected = false;
    this.initiativeName = null;


    this.approveOrRejectHoshin = false;
    this.approvedAmount = null;
    this.hoshinApproveClicked = false;
    this.approveRejectComment = "";
    this.hoshinApproved = false;
    this.hoshinRejected = false;
    this.hoshinSubmitted = false;
    this.readOnly = false;
    this.isSuperAdminApproved = false;
    this.isAllHoshinsApproved = false;
    this.isAnyInitiativeRejected = false;
    this.resetHoshinEvaluation = [];
    this.totalProposedBudget = null;
    this.totalApprovedBudget = null;
    this.adminsEdit = false;
    this.claimedAmount = null;
    this.pastHoshinList = [];
    this.printHoshinsList = [];
    this.currentHoshin = [];
    this.getYears();
  }

  changeIsActive(data) {
    this.yearList.map((res) => {
      if (res === data) {
        res.isActive = true;
      } else {
        res.isActive = false;
      }
    });
    this.getHoshinDetails(data.year, data.type);
    this.kpiName = null;
    this.selectedKpi = null;
    this.kpi = null;
    this.kpiCount = null;
    this.addCustomKpi = false;
    this.isKpiClicked = false;
    this.isDetailsClicked = true;
    this.cloneDisable = false;
    this.isAddNewInitiativeSelected = false;
  }

  getYears(type?: string) {
    this.selectedChapter = true;
    const userData = {
      userId: this.userId,
      adminId: this.adminId,
      siteId: this.siteId,
      bpgId: this.bpgId
    };
    this.hoshinService.getHoshinYears(userData).subscribe((res) => {
      this.spinner.show();
      if (res != null && res !== undefined) {
        this.yearList = res;
        if (type === 'saveReview') {

          this.yearList.map((res) => {
            if (res.year === this.reviewSubmittedYear + 1 && res.type === 'plan') {
              res.isActive = true;
            } else {
              res.isActive = false;
            }
          });
          this.getHoshinDetails(this.reviewSubmittedYear + 1, 'plan');
        } else {

          this.yearList.map((res) => {
              res.isActive = false;
          });
          if(this.yearList.length>1  && this.yearList[1].enabled === true){
            this.getHoshinDetails(this.yearList[1].year, this.yearList[1].type);
            this.yearList[1].isActive = true;
          }else{
            this.getHoshinDetails(this.yearList[0].year, this.yearList[0].type);
            this.yearList[0].isActive = true;
          }
          
        }

      }
    });
  }
  getLeadDetails() {
    const landingDto = {
      filter: {
        chapterId: this.chapterId,
      },
      moduleId: 0,
      page: 0,
      presentRole: "",
      searchTerm: "",
      size: 0,
      sortDirection: "ASC",
      sortProperty: "",
      uid: "",
    };
    this.userService.getUserDropDown(landingDto).subscribe((data) => {
      this.userList = data;
      this.userList.map((i) => {
        i.userFirstName = `${i.userFirstName} ${i.userLastName}`;
        return i;
      });
    });
  }
  toggleCheckbox(e: MatCheckboxChange) {
    if (e.checked) {
      this.hoshinApproveClicked = true;
    } else {
      this.hoshinApproveClicked = false;
    }
  }
  getHoshinDetails(fiscalYear, type, flag?: string) {
    this.spinner.show();
    this.submitButtonClicked = false;
    this.hoshinSuccess = false;
    this.isGoalsSelected = true;
    this.isInitiativesSelected = false;
    this.isEditKpi = false;
    this.displayType = type;
    this.isAddNewInitiative = false;
    this.kpiSuccess = false;
    this.approveOrRejectHoshin = false;
    this.newApprovedAmountGreater = false;
    this.errorMsg = '';
    const hoshinData = {
      userId: this.userId,
      adminId: this.adminId,
      fiscalYear: fiscalYear,
      type: type,
      siteId: this.siteId,
      bpgId: this.bpgId
    };
    this.fiscalYear = fiscalYear;
    this.fiscalYearString = (this.fiscalYear-1).toString();
    if (type === "plan") {
      this.prevFy = Number(fiscalYear) - 1;
      this.prevFyShort = String(this.prevFy).substring(2, 5);
    }
    // adjust minDate and maxDate accordingly to fiscalYear
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    // If the month is before April, the fiscal year is the previous year
    if (month < 4) {
        this.currentFiscalYear = year;
    } else {
        this.currentFiscalYear = year+1;
    }
    if(this.currentFiscalYear < fiscalYear){
      this.minDate = new Date(this.fiscalYear - 1 + "/04/01");
      this.maxDate = new Date(this.fiscalYear + "/03/30");
    }else{
      this.minDate = new Date(this.fiscalYear - 1 + "/"+month.toString() + "/01");
      this.maxDate = new Date(this.fiscalYear + "/03/30");
    }
    this.hoshinService.getHoshinForSingleUser(hoshinData).subscribe((res) => {
      if (res != null && res !== undefined) {
        this.spinner.hide();

        this.siteName = res.siteName;
        this.bpgName = res.bpgName;
        this.chapterId = res.chapterId;
        this.overallStatus = res.overallStatus;
        this.isAllHoshinsApproved = res.isAllHoshinsApproved;
        this.isAnyInitiativeRejected = res.isAnyInitiativeRejected;
        this.totalProposedBudget = res.totalProposedBudget;
        this.totalApprovedBudget = res.totalApprovedBudget;
        if (this.overallStatus === 'DRAFT' || this.overallStatus === 'NEW') {
          this.readOnly = false;
        }
        if (this.overallStatus === 'SUBMITTED') {
          this.readOnly = true;
        }
        else if (this.overallStatus === 'APPROVED') {
          if (this.adminId === '1') {
            this.readOnly = false;
            this.adminsEdit = true;
          } else {
            this.readOnly = true;
            this.adminsEdit = false;
          }

        }
        else if (this.overallStatus === 'REJECTED') {
          this.adminsEdit = false;
          this.readOnly = false;
        }
        if (type === "plan") {
          if (
            res.currentYearDetails != null &&
            res.currentYearDetails !== undefined
          ) {
            this.chapterGoals = res.currentYearDetails["chapterGoals"];
            this.chapterGoals = new DOMParser().parseFromString(this.chapterGoals, "text/html").documentElement.textContent;
            this.affinityGoals = res.currentYearDetails["affinityGoals"];
            this.affinityGoals = new DOMParser().parseFromString(this.affinityGoals, "text/html").documentElement.textContent;
            this.initiativeList = res.currentYearDetails["initiativeList"];
            this.goalsReview = res.currentYearDetails["goalsReview"];
          }
          if (res.prevYearDetails != null && res.prevYearDetails !== undefined) {
            this.prevchapterGoals = res.prevYearDetails["chapterGoals"];
            this.prevchapterGoals = new DOMParser().parseFromString(this.prevchapterGoals, "text/html").documentElement.textContent;
            this.prevAffinityGoals = res.prevYearDetails["affinityGoals"];
            this.prevAffinityGoals = new DOMParser().parseFromString(this.prevAffinityGoals, "text/html").documentElement.textContent;
            this.prevInitiativeList = res.prevYearDetails["initiativeList"];
          }
          // make initiatives selected by default if goals are filled
          if((this.affinityGoals !== null && this.affinityGoals !== undefined && this.affinityGoals !== '') && (this.chapterGoals !== null && this.chapterGoals !== undefined && this.chapterGoals !== '')){
            this.selectInitiative();
          }
          // copy from prev years
          if (this.affinityGoals === null || this.affinityGoals === undefined || this.affinityGoals === '') {
            this.affinityGoals = this.prevAffinityGoals;
          }
          if (this.chapterGoals === null || this.chapterGoals === undefined || this.chapterGoals === '') {
            this.chapterGoals = this.prevchapterGoals;
          }
          if (this.initiativeList.length > 0) {
            for (const initiative of this.initiativeList) {
              if (initiative.isCloned) {
                this.cloneDisable = true;
                break;
              }
            }
          }
          this.getLeadDetails();
          if (flag === 'saveHoshin' || flag === 'cancelKpi') {
            this.calculateMissingMandatoryFields();
            this.calculateMissingKpi();
          }

        }
        if (type === "reflection") {
          this.isOverallReviewSelected = true;
          this.isKpiReviewSelected = false;
          if (
            res.currentYearDetails != null &&
            res.currentYearDetails !== undefined
          ) {
            this.isNextYearPlanCompleted = res.isNextYearPlanCompleted;
            this.hoshinList = res.currentYearDetails["initiativeList"];
            if (this.hoshinList.length > 0) {
              this.isKpiReviewSelected = true;
              this.isOverallReviewSelected = false;
            }
            this.highlights = res.currentYearDetails["challenges"];
            this.challenges = res.currentYearDetails["highlights"];
            this.calculateMissingFieldsInReflectionScreen();
          }
        }
      }
    });
  }

  editHoshin(data, flag?: string) {
    this.submitButtonClicked = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = false;
    this.isAddNewInitiativeSelected = true;
    this.isAddNewInitiative = true;
    this.initiativeName = data.bpgInitiative;
    this.bpgInitiative = data.bpgInitiative;
    this.businessDrivers = data.businessDrivers;
    this.frequency = data.frequency;
    this.isAdditionalFundingSelected = data.isAdditionalFundingSelected;
    this.proposedBudget = data.proposedBudget;
    this.claimedAmount = data.claimedAmount;
    this.approvedBudget = data.superAdminApprovedBudget;
    this.leadId1 = data.leadId1;
    this.leadId2 = data.leadId2;
    this.additionalFunding = data.additionalFunding;
    this.additionalFundingSource = data.additionalFundingSource;
    this.actionPlan = data.actionPlan;
    this.actionPlan = new DOMParser().parseFromString(this.actionPlan, "text/html").documentElement.textContent;
    this.estimatedTiming = data.estimatedTiming;
    this.hoshinId = data.hoshinId;
    this.selectedKpiList = data.selectedKpiList ? data.selectedKpiList : [];
    let count = 0;
    if (this.selectedKpiList.length >= 1) {
      this.selectedKpiList.map((res) => {
        if (res.isMasterKpi) {
          count++;
        }
      });
    }
    this.enableSaveInitiativeButton = count>0 ? true : false;
    this.kpiList = data.kpiList;
    this.superAdminApprovalComments = data.superAdminApprovalComment;
    this.isSuperAdminApproved = data.isSuperAdminApproved;
    if (flag === 'approval') {
      this.addApproverComments();
    }
  }

  saveHoshin() {
    this.hoshinSuccess = false;
    this.newApprovedAmountGreater = false;
    let remainAmount = 0;
    const remainList = [];
    this.enableSaveInitiative();
    if (this.initiativeList.length > 0) {
      for (const initiative of this.initiativeList) {
        if (initiative.hoshinId !== this.hoshinId) {
          remainList.push(initiative)
        }
      }

      remainList.forEach(res1 => {
        remainAmount += res1.superAdminApprovedBudget
      })
      remainAmount += this.approvedBudget
    }

    if (this.overallStatus === 'APPROVED' && this.newApprovedAmountGreater) {
      this.spinner.hide();

    } else {
      this.spinner.show();
      const iniativeData = {
        chapterId: this.chapterId,
        fiscalYear: this.fiscalYear,
        bpgInitiative: this.bpgInitiative,
        businessDrivers: this.businessDrivers,
        frequency: this.frequency,
        estimatedTiming: this.estimatedTiming,
        proposedBudget: this.proposedBudget,
        leadId1: this.leadId1,
        leadId2: this.leadId2,
        additionalFunding: this.additionalFunding,
        additionalFundingSource: this.additionalFundingSource,
        actionPlan: this.actionPlan,
        userId: this.userId,
        hoshinId: this.hoshinId,
        superAdminApprovedBudget: this.approvedBudget,
        isAdditionalFundingSelected: this.isAdditionalFundingSelected
      };
      this.hoshinService.saveHoshinInitiative(iniativeData).subscribe((res) => {
        if (res != null && res !== undefined) {
          this.hoshinId = res.hoshinId;
          //added to update error message
          this.initiativeList.map((initiative) => {
            if (initiative.hoshinId === this.hoshinId) {
              initiative.bpgInitiative = res.bpgInitiative;
              initiative.businessDrivers = res.businessDrivers;
              initiative.frequency = res.frequency;
              initiative.estimatedTiming = res.estimatedTiming;
              initiative.proposedBudget = res.proposedBudget;
              initiative.leadId1 = res.leadId1;
              initiative.leadId2 = res.leadId2;
              initiative.additionalFunding = res.additionalFunding;
              initiative.additionalFundingSource = res.additionalFundingSource;
              initiative.actionPlan = res.actionPlan;
              initiative.superAdminApprovedBudget = res.superAdminApprovedBudget;
              initiative.isAdditionalFundingSelected = res.isAdditionalFundingSelected;
              if (res.frequency === 'Once' && res.estimatedTiming != null && res.estimatedTiming !== "") {
                initiative.isValid = true;
              }
            }
          });
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
          setTimeout(() => {
            this.isDetailsClicked = false;
            this.isKpiClicked = true;
            this.approveOrRejectHoshin = false;
            this.calculateMissingKpi();
            this.calculateMissingMandatoryFields();
            this.spinner.hide();
          }, 2000);
        }
      });
    }
  }
  saveGoals() {
    this.spinner.show();
    this.errorMsg = '';
    const goalData = {
      chapterId: this.chapterId,
      fiscalYear: this.fiscalYear,
      chapterGoals: this.chapterGoals,
      affinityGoals: this.affinityGoals,
      goalsReview: this.goalsReview,
      createdBy: this.userId,
    };
    this.hoshinService.saveHoshinGoals(goalData).subscribe((data) => {
      if (this.overallStatus === 'NEW') {
        this.overallStatus = 'DRAFT';
      }
      window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
      if (data != null && data !== undefined) {
        setTimeout(() => {
          this.selectInitiative();
          this.spinner.hide();
        }, 2000);
      }
    });
  }
  toggleFundingCheckbox(e: MatCheckboxChange) {
    if (e.checked) {
      this.isAdditionalFundingSelected = true;
    } else {
      this.isAdditionalFundingSelected = false;
    }
  }
  resetHigh() {
    this.challenges = "";
    this.highlights = "";
  }

  deleteHoshin(hoshinId) {
    this.param = hoshinId;
    this.msg = " Are you sure you want to delete the Hoshin Initiative ? ";
    this.method = "deleteHoshinConfirmation";
  }
  deleteHoshinConfirmation(hoshinId) {
    this.submitButtonClicked = false;
    this.hoshinService
      .deleteHoshinInitative(this.userId, hoshinId)
      .subscribe((data) => {
        this.spinner.hide();
        if (data != null && data !== undefined) {

          this.initiativeList = this.initiativeList.filter(
            (res) => res.hoshinId !== hoshinId
          );
          this.calculateMissingKpi();
          this.calculateMissingMandatoryFields();
          let isClonedInitiativePresent = 0;
          this.initiativeList.map((res) => {
            if (res.isCloned) {
              isClonedInitiativePresent += 1;
            }
          });
          if (isClonedInitiativePresent === 0) {
            this.cloneDisable = false;
          }
        }
      });
  }
  addNewKpi(data) {
    if (data === "add") {
      let kpiAlreadyAdded = false;
      this.kpiExist = false;
      if (this.kpiNameEditable) {
        this.selectedKpiList.map((res) => {
          if (this.selectedKpi === res.kpiId) {
            this.kpiExist = true;
            kpiAlreadyAdded = true;
            window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            setTimeout(() => {
              this.kpiExist = false;
            }, 2000);
          }
        });
        if (!kpiAlreadyAdded) {
          this.kpiList.map((res) => {
            if (this.selectedKpi === res.kpiId) {
              res.kpiCount = this.kpiCount;
              this.selectedKpiList = [...this.selectedKpiList, ...res];
            }
          });
        }
      } else {
        this.selectedKpiList.map((res) => {
          if (this.kpiName.toLowerCase() === res.kpiName.toLowerCase()) {
            this.kpiExist = true;
          }
        });
        if (this.kpiExist) {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
          setTimeout(() => {
            this.kpiExist = false;
          }, 2000);
        } else {
          this.isEditKpi = false;
          this.newkpiCount += 1;
          this.selectedKpi = "newKpi" + this.newkpiCount.toString();
          const newKpi = [
            {
              kpiId: this.selectedKpi,
              kpiName: this.kpiName,
              kpiCount: this.kpiCount,
            },
          ];
          this.selectedKpiList = [...this.selectedKpiList, ...newKpi];
        }

      }
    } else {
      this.selectedKpiList.map((res) => {
        if (this.selectedKpi === res.kpiId) {
          res.kpiCount = this.kpiCount;
          res.kpiName = this.kpiName;
        }
      });
    }
    this.kpiName = null;
    this.kpiCount = null;
    this.addCustomKpi = false;
    this.kpiNameEditable = false;
    this.isEditKpi = false;
    this.kpi = null;
    this.enableSaveInitiative();

  }

  // check whether min to one kpis from dropdown is selected to enable save initiative button
  enableSaveInitiative() {
    let count = 0;
    if (this.selectedKpiList.length >= 1) {
      this.selectedKpiList.map((res) => {
        if (res.isMasterKpi) {
          count++;
        }
      });
    }
    if (count >= 1) {
      this.enableSaveInitiativeButton = true;
    } else {
      this.enableSaveInitiativeButton = false;
    }
  }

  manageKpi(event) {
    this.addCustomKpi = true;
    this.kpiName = event.kpiName;
    this.selectedKpi = event.kpiId;
    this.kpiNameEditable = true;
    this.kpiExist = false;
  }
  editKpi(data) {
    this.kpiList.map((res) => {
      if (data.kpiId === res.kpiId) {
        this.kpiNameEditable = true;
      }
    });
    this.addCustomKpi = true;
    this.isEditKpi = true;
    this.selectedKpi = data.kpiId;
    this.kpiName = data.kpiName;
    this.kpiCount = data.kpiCount;
  }

  manageCustomKpi() {
    this.kpiNameEditable = false;
    this.addCustomKpi = true;
    this.kpi = null;
    this.kpiName = null;
    this.kpiCount = null;
  }
  deleteKpi(data) {
    this.isEditKpi = false;
    this.kpi = null;
    if (data.isActive) {
      this.hoshinService
        .deleteHoshinKpi(this.hoshinId, data.kpiId, this.userId)
        .subscribe((res) => {
          if (res != null && res !== undefined) {
            this.selectedKpiList = this.selectedKpiList.filter(
              (res) => res.kpiId !== data.kpiId
            );
            if (this.selectedKpiList.length === 0) {
              this.initiativeList.map((response) => {
                if (response.hoshinId === this.hoshinId) {
                  response.selectedKpiList = [];
                }
              });
            }
            this.enableSaveInitiative();
          }
        });
    } else {
      this.selectedKpiList = this.selectedKpiList.filter(
        (res) => res.kpiId !== data.kpiId
      );
      if (this.selectedKpiList.length === 0) {
        this.initiativeList.map((response) => {
          if (response.hoshinId === this.hoshinId) {
            response.selectedKpiList = [];
          }
        });
      }
    }
  }
  saveKpi() {
    this.spinner.show();
    this.selectedKpiList.map((res) => {
      if (
        (res.isMasterKpi === null ||
          res.isMasterKpi === undefined ||
          res.isMasterKpi === "") &&
        (res.isActive === null ||
          res.isActive === undefined ||
          res.isActive === "")
      ) {
        res.kpiId = 0;
      }
    });
    const kpiData = {
      hoshinId: this.hoshinId,
      selectedKpiList: this.selectedKpiList,
      userId: this.userId,
      fiscalYear: this.fiscalYear,
      chapterId: this.chapterId,
    };

    this.hoshinService.saveHoshinKpi(kpiData).subscribe((res) => {
      this.spinner.hide();
      if (res != null && res !== undefined) {
        this.kpiSuccess = true;
        this.kpi = null;
        const hoshinId = res.hoshinId;
        this.initiativeList.map((response) => {
          if (response.hoshinId === hoshinId) {
            response.selectedKpiList = res.selectedKpiList;
          }
        });

        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.kpiSuccess = false;
          // to update all error messages
          this.getHoshinDetails(this.fiscalYear, 'plan', 'saveHoshin');
          this.calculateMissingKpi();
          this.calculateMissingMandatoryFields();
          this.errorMsg = "";
          this.isGoalsSelected = false;
          this.isInitiativesSelected = true;
          this.isKpiClicked = false;
          this.isDetailsClicked = true;
          this.isAddNewInitiativeSelected = false;
        }, 2000);
      }
    });
  }

  selectGoals() {
    this.submitButtonClicked = false;
    this.isGoalsSelected = true;
    this.isInitiativesSelected = false;
    this.newApprovedAmountGreater = false;
    this.errorMsgForMissingKpi = ''
  }
  selectInitiative() {
    this.submitButtonClicked = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = true;
    this.isCloned = true;
    this.isAddNewInitiativeButtonSelected = true;
    this.errorMsg = '';
    this.calculateMissingKpi();
    this.calculateMissingMandatoryFields();

  }
  selectGoalsReview() {
    this.submitButtonClicked = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = false;
    this.newApprovedAmountGreater = false;
    this.errorMsgForMissingKpi = '';
  }
  copyData(data) {
    if (data === "affinityGoals") {
      this.affinityGoals = this.prevAffinityGoals;
    }
    if (data === "chapterGoals") {
      this.chapterGoals = this.prevchapterGoals;
    }

    if (data === "iniative") {
      this.spinner.show();
      this.submitButtonClicked = false;
      this.isGoalsSelected = false;
      this.isInitiativesSelected = true;
      this.isCloned = false;
      this.isAddNewInitiativeButtonSelected = true;
      const cloneData = {
        initiativeList: [],
        userId: this.userId,
        fiscalYear: Number(this.fiscalYear) - 1,
        chapterId: this.chapterId,
      };
      this.hoshinService.cloneHoshins(cloneData).subscribe((res) => {
        this.spinner.hide();
        if (res != null && res !== undefined) {
          this.cloneDisable = true;
          this.overallStatus = 'DRAFT';
          this.prevInitiativeList = res.initiativeList ? res.initiativeList : [];
          for (const pre of this.prevInitiativeList) {
            pre.isCloned = true;
          }
          this.initiativeList = [
            ...this.initiativeList, ...this.prevInitiativeList

          ];
          this.calculateMissingKpi();
          this.calculateMissingMandatoryFields();
          setTimeout(() => {
            this.isCloned = true;
          }, 1000);
        }
      });
    }
  }
  addNewInitiative() {
    this.submitButtonClicked = false;
    this.initiativeName = "New Initiative";
    this.isGoalsSelected = false;
    this.isInitiativesSelected = false;
    this.isCloned = true;
    this.isAddNewInitiativeButtonSelected = true;
    this.resetHoshinInitiative();
    this.isAddNewInitiative = true;
    this.kpiSuccess = false;
    this.hoshinId = 0;
    this.isSuperAdminApproved = null;
  }

  resetHoshinInitiative() {
    this.newApprovedAmountGreater = false;
    this.bpgInitiative = "";
    this.frequency = null;
    this.proposedBudget = null;
    this.leadId1 = null;
    this.leadId2 = null;
    this.additionalFunding = null;
    this.additionalFundingSource = null;
    this.actionPlan = null;
    this.estimatedTiming = null;
    this.selectedKpiList = [];
    this.kpiList = [];
    this.businessDrivers = null;
    this.isAdditionalFundingSelected = false;
    this.approvedBudget = null;
  }
  resetKpi(data?: string) {
    if (data === 'cancelKpi') {
      this.getHoshinDetails(this.fiscalYear, 'plan', data);
    }
    this.newApprovedAmountGreater = false;
    this.isAddNewInitiativeSelected = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = true;
    this.isCloned = true;
    this.isAddNewInitiativeButtonSelected = true;
    this.isAddNewInitiative = false;
    this.kpiName = null;
    this.selectedKpi = null;
    this.kpi = null;
    this.kpiCount = null;
    this.addCustomKpi = false;
    this.isKpiClicked = false;
    this.isDetailsClicked = true;
    this.hoshinApproved = false;
    this.hoshinRejected = false;
    this.approveOrRejectHoshin = false;
  }
  detailsClick() {
    this.isDetailsClicked = true;
    this.isKpiClicked = false;
    this.approveOrRejectHoshin = false;
  }
  kpiClick() {
    this.isDetailsClicked = false;
    this.isKpiClicked = true;
    this.approveOrRejectHoshin = false;
    this.enableSaveInitiative();
  }
  approveOrReject(type) {
    this.method = 'approveOrRejectConfirmation';
    this.param = type;
    if (type === 'APPROVED') {
      this.msg = 'Are you sure you want to approve the Hoshin?'

    }
    else {
      this.msg = 'Are you sure you want to reject the Hoshin?'
    }
  }

  approveOrRejectConfirmation(type) {
    this.spinner.show();
    const submitData = {
      "userId": this.userId,
      "overallStatus": type,
      "chapterId": this.chapterId,
      "fiscalYear": this.fiscalYear,
      "type": "overall"
    }
    this.hoshinService.approveorRejectHoshin(submitData).subscribe((res) => {
      this.spinner.hide();
      if (res != null && res !== undefined) {
        this.overallStatus = res.overallStatus;
        if (this.overallStatus === 'APPROVED') {
          this.hoshinSubmitted = true;
          this.adminsEdit = true;
          this.readOnly = false;
          this.overallHoshinApproved = true;
        } else {
          this.hoshinSubmitted = false;
          this.adminsEdit = false;
          this.readOnly = false;
          this.overallHoshinRejected = true;
        }
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.overallHoshinApproved = false;
          this.overallHoshinRejected = false;
          this.getHoshinDetails(this.fiscalYear, 'plan');
        }, 2000);

      }
    });

  }
  addApproverComments() {
    this.isDetailsClicked = true;
    this.isKpiClicked = true;
    this.approveOrRejectHoshin = true;
    this.hoshinApproveClicked = false;
    this.approvedAmount = null;

    this.approveRejectComment = "";
    this.initiativeList.map((response) => {
      if (response.hoshinId === this.hoshinId) {
        if (response.isSuperAdminApproved) {
          this.hoshinApproveClicked = response.isSuperAdminApproved;
          this.isSuperAdminApproved = response.isSuperAdminApproved
          this.approveRejectComment = response.superAdminApprovalComment ? response.superAdminApprovalComment : '';
          this.approvedAmount = response.superAdminApprovedBudget ? response.superAdminApprovedBudget : null;
        }
        else {
          this.isSuperAdminApproved = false;
          this.approveRejectComment = response.superAdminApprovalComment ? response.superAdminApprovalComment : '';

        }

      }
    });
  }
  selectKPIsReview() {
    this.submitButtonClicked = false;
    this.isKpiReviewSelected = true;
    this.isOverallReviewSelected = false;
  }
  selectOverallReview() {
    this.submitButtonClicked = false;
    this.isKpiReviewSelected = false;
    this.isOverallReviewSelected = true;
    this.errorMsg = '';

  }

  submitApproval(msg) {
    this.method = "submitApprovalConfirmation";
    if (msg === "approve") {
      this.msg = "Are you sure you want to approve the Initiative?";
    } else {
      this.msg = "Are you sure you want to reject the Initiative?";
    }
  }

  submitApprovalConfirmation() {
    this.spinner.show();
    this.approvedAmount = this.hoshinApproveClicked ? this.approvedAmount : 0;
    const approvalData = {
      userId: this.userId,
      hoshinId: this.hoshinId,
      isApproved: this.hoshinApproveClicked,
      approvalAmount: this.approvedAmount,
      comments: this.approveRejectComment,
      type: "individual",
    };

    this.hoshinService.approveorRejectHoshin(approvalData).subscribe((res) => {
      if (res != null && res !== undefined) {
        this.spinner.hide();
        this.totalApprovedBudget = res.totalApprovedBudget;
        if (this.hoshinApproveClicked) {
          this.hoshinApproved = true;
          this.hoshinRejected = false;
        } else {
          this.hoshinApproved = false;
          this.hoshinRejected = true;
        }
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.hoshinApproved = false;
          this.hoshinRejected = false;
          this.getHoshinDetails(this.fiscalYear, this.displayType);
          this.isGoalsSelected = false;
          this.isInitiativesSelected = true;
          this.isAddNewInitiativeSelected = false;
          this.isKpiClicked = false;
        }, 2000);
      }
    });
  }
  /** month year selection
   * @class CreateAndEditHoshinComponent
   * @method onOpenCalendar
   */
  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode("month");
  }
  /** on date change
   * @class CreateAndEditHoshinComponent
   * @method onDateChange
   */
  onDateChange(event, _i) {
    this.selectedMonthYear = event;
    const date = new Date(this.selectedMonthYear);
    const transformdate = this.datepipe.transform(date, "MMMM yyyy");
    this.estimatedTiming = transformdate.toString();
  }
  getBaseHoshin(data, i) {
    this.hoshinBase = data;
    this.isViewClicked = true;
    document.getElementById('bsaeHoshin' + i).setAttribute(this.dataTargetConstant, '#bpgBaseModal');
    document.getElementById('bsaeHoshin' + i).setAttribute(this.dataToggleConstant, 'modal');
  }
  getKpi() {
    this.spinner.show();
    this.kpiList = [];
    this.hoshinService.getKpiDetails(this.businessDrivers).subscribe((data) => {
      this.kpiList = data;
      this.spinner.hide();
    });
  }
  calculateMissingFieldsInReflectionScreen() {
    this.kpiReviewMissingFields = '';
    this.overallReviewMissingFields = '';
    let evaluationError = false;

    for (const h of this.hoshinList) {
      if (h.evaluation !== '' && h.evaluation != null) {
        //do nothing
      } else {
        evaluationError = true;
        break;
      }
    }
    if (evaluationError) {
      this.kpiReviewMissingFields = "Please fill evaluation for all the Initiatives";
    }
    if (
      this.challenges === null ||
      this.challenges === undefined ||
      this.challenges === "" ||
      this.highlights === null ||
      this.highlights === undefined ||
      this.highlights === "" ||
      evaluationError
    ) {

      if (
        this.highlights === null ||
        this.highlights === undefined ||
        this.highlights === ""
      ) {
        if (this.overallReviewMissingFields === "") {
          this.overallReviewMissingFields = "Please fill Highlights";
        }
      }
      if (
        this.challenges === null ||
        this.challenges === undefined ||
        this.challenges === ""
      ) {
        if (this.overallReviewMissingFields === "") {
          this.overallReviewMissingFields = "Please fill Challenges";
        } else {
          this.overallReviewMissingFields += " and " + "Challenges";
        }
      }
    }
  }
  checkAllMandatoryDetailsFilledForReview(data) {
    this.submitButtonClicked = true;
    this.calculateMissingFieldsInReflectionScreen();
    if (data === 'kpiReview') {
      if (this.kpiReviewMissingFields === '') {
        this.updateReview(data);
      }
    } else if (this.overallReviewMissingFields === '') {
        this.updateReview(data);
      }
  }

  updateReview(type) {
    this.submitButtonClicked = false;
    // added for showing overallreview on click of save button
    let isKPIEvaluationCompleted = false;
    this.spinner.show();
    this.errorMsg = '';
    const kpiReveiwList = [];
    this.hoshinList.forEach((initiative) => {
      if (initiative.evaluation != null && initiative.evaluation !== "") {
        this.saveKPIReviewDTO = {
          hoshinId: initiative.hoshinId,
          evaluation: initiative.evaluation
        }
        kpiReveiwList.push(this.saveKPIReviewDTO);
      }
      if (kpiReveiwList.length === this.hoshinList.length) {
        isKPIEvaluationCompleted = true;
      }
    });
    const reviewData = {
      initiativeList: kpiReveiwList,
      challenges: this.challenges,
      highlights: this.highlights,
      fiscalYear: this.fiscalYear,
      type: "review",
      userId: this.userId,
      chapterId: this.chapterId,
    };
    this.hoshinService.saveHoshinReview(reviewData).subscribe((data) => {

      if (data) {
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        if (type === 'kpiReview') {
          this.selectOverallReview();
          this.spinner.hide();
        } else if (type === 'partialSave') {
          if (isKPIEvaluationCompleted) {
            this.kpiReviewMissingFields = '';
            this.isAddNewInitiative = false;
            this.selectOverallReview();
          } else {
            this.kpiReviewSaved = true;
          }
          this.spinner.hide();
        } else {
          this.reviewSubmittedYear = this.fiscalYear;
          this.getYears('saveReview');
        }
        if (this.kpiReviewSaved) {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
          setTimeout(() => {
            this.kpiReviewSaved = false;
          }, 2000);
        }
      }
    });
  }
  submitPlanAndReview() {
    this.submitButtonClicked = true;
    this.errorMsg = "";
    this.calculateMissingKpi();
    this.calculateMissingMandatoryFields();
    if (this.initiativeList.length === 0) {
      if (this.errorMsg === "") {
        this.errorMsg = "Please fill atleast an Initiative to Submit";
      } else {
        this.errorMsg += ", " + "Initiatives";
      }
    }

    if (this.errorMsg === "" && this.errorMsgForMissingKpi === "" && this.errorMsgForMissingMandatoryFields === "") {
      document.getElementById("submitButton").setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById("submitButton").setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "ConfirmSubmitPlanAndReview";
      this.msg = "Are you sure you want to submit the Hoshin?";
    } else {
      this.submitButtonClicked = true;
      document.getElementById('submitButton').removeAttribute(this.dataToggleConstant);
      document.getElementById('submitButton').removeAttribute(this.dataTargetConstant);
    }
  }
  ConfirmSubmitPlanAndReview() {
    this.spinner.show();
    this.submitButtonClicked = false;
    const submitData = {
      chapterId: this.chapterId,
      userId: this.userId,
      planYear: this.fiscalYear,
      reviewYear: Number(this.fiscalYear) - 1,
      type: 'submit'
    };
    this.hoshinService.submitHoshin(submitData).subscribe((res) => {
      if (res != null && res !== undefined) {
        this.spinner.hide();
        this.hoshinSubmitted = true;
        this.hoshinSubmit = true;
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.hoshinSubmit = false;
          if (this.adminId !== '1') {
            this.readOnly = true;
          }

          this.getHoshinDetails(this.fiscalYear, 'plan');
        }, 2000);


      }
    });

  }
  calculateMissingKpi() {
    this.errorMsgForMissingKpi = "";
    if (this.initiativeList.length > 0 && this.fiscalYear > 2025) {
      this.initiativeList.map((i) => {
        if (i.selectedKpiList === null || i.selectedKpiList.length < 1) {
          if (this.errorMsgForMissingKpi === "") {
            this.errorMsgForMissingKpi = i.bpgInitiative;
          } else {
            this.errorMsgForMissingKpi += ", " + i.bpgInitiative;
          }
        }
      });
    }
  }
  calculateMissingMandatoryFields() {
    this.errorMsgForMissingMandatoryFields = "";
    if (this.initiativeList.length > 0) {
      this.initiativeList.map((i) => {
        if (i.isValid === false || i.actionPlan === "" || i.actionPlan === null) {
          if (this.errorMsgForMissingMandatoryFields === "") {
            this.errorMsgForMissingMandatoryFields = i.bpgInitiative;
          } else {
            this.errorMsgForMissingMandatoryFields += ", " + i.bpgInitiative;
          }
        }
      });
    }
  }
  screenExit() {
    this.msg = "Are you sure you want to leave this page?";
    this.method = "confirmExit";
  }
  confirmExit() {
    this.router.navigate(["/hoshin-home"]);
  }
  printHoshin() {
    this.printClicked = true;
    const printContents = document.getElementById("printHoshins").innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    this.spinner.hide()
    window.print();

    document.body.innerHTML = originalContents;
    window.location.reload();
    setTimeout(
      function () {
        this.printClicked = false;
      }.bind(this),
      1000
    );
  }

  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "Hoshin"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }
}
